<template>
  <div class="contentscoll">
    <div class="titlse">{{data[2].Title}}</div>
    <div class="t1">第{{data[2].Listid}}期 > {{cate}} {{data[2].Issue_date.substring(0,10)}}</div>
    <div>
        <div class="content">{{data[0].Phname}}</div>
        <div class="content" v-html="data[0].Contents"></div>
        <div class="content">{{data[1].Phname}}</div>
        <div class="content" v-html="data[1].Contents"></div>
    </div>
   <div style="height:0.95rem;width:100%;"></div>
   <!-- <van-tabbar active-color="#1989fa"  inactive-color="#000" route>
      <van-tabbar-item replace to="/DeptTitle" icon="apps-o">科室分类</van-tabbar-item>
      <van-tabbar-item replace to="/PublicTime" icon="clock-o">发布时间</van-tabbar-item>
      <van-tabbar-item replace to="/Search" icon="search">搜索</van-tabbar-item>    
    </van-tabbar> -->
  </div>
</template>

<script>
import Nav from  './Nav'
export default {
  name: 'DeptContent',  
  components:{
      Nav
  },
  props:{
    contentdetail:{
              type:Array,
              default:()=>[]
            }
    },
  data () {
    return {
        data:[],
        cate:''
    }
  },
  created(){
    this.data=this.contentdetail;
    // console.log(this.data)
    switch(this.data[2].Category){
      case 1:
      this.cate='临床应用';
      break;
      case 2:
      this.cate='用药安全';
      break;
      case 3:
      this.cate='新药信息';
      break;
      case 4:
      this.cate='研究动态';
      break;
      case 5:
      this.cate='医药动态';
      break;
      case 6:
      this.cate='用户交流';
      break;
      case 7:
      this.cate='MCDEX快递';
      break;
    }
  },
  methods:{    
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content{
    font-size: 0.14rem;
    padding: 0.1rem 0.12rem;
    word-break: break-all;
}
.titlse{
  font-size: 0.18rem;
  padding: 0.1rem;
  font-weight: 700;
}
.t1{
  font-size: 0.12rem;
  color: #333;
  padding:0 0.1rem 0.1rem;
  border-bottom: 0.05rem solid #F2EEEE;
}
</style>



// WEBPACK FOOTER //
// src/components/DeptContent.vue